import { ApiError } from "@vana/core";

export class ListBatchesError extends ApiError {}

export class ListInventoryError extends ApiError {}

export class CreateBatchError extends ApiError {}

export class AdvanceBatchError extends ApiError {}

export class ReceiveBatchError extends ApiError {}

export class ReconcileBatchError extends ApiError {}

export class ListHoldingsError extends ApiError {}

export class DistributeError extends ApiError {}

export class ListReceptionsError extends ApiError {}

export class RecordReceptionError extends ApiError {}

export class ListCustodyError extends ApiError {}

export class UploadCustodyDocError extends ApiError {}

export class RecordCustodyError extends ApiError {}
